<div class="flex-v">
    <div>
        <app-date-slider [leftBtnPosition]="startPercentage" [rightBtnPosition]="endPercentage"
            (onChange)="onDateSliderChange($event)" [leftTooltipTpl]="left" [rightTooltipTpl]="right">
        </app-date-slider>
    </div>
    <div class="flex-h-c f-w mt2em align-start">
        <div class="pct50 flex-v pr2em">
            <span class="sec-color pl2 f12">Start Date</span>
            <div class="flex-h-c pct100 mt8">
                <div class="f-g f-s">
                    <ad-dropdown-list class="pct100" [isEmitChangeOutside]="false" [cssClass]="'dd-rounded-border'"
                        defaultText="{{customDateStart?(customDateStart | date:format):'Select a start date'}}"
                        [dataSource]="startDateItemOptions" textAlign="left" width="100%"
                        (onChange)="onStartDateItemChange()" [(ngModel)]="selectedStartOption"></ad-dropdown-list>
                </div>
                <i class="fas fa-calendar poi primary-color f20 ml14" (click)="isStartOpen = !isStartOpen"></i>
            </div>
            <div class="rel a-drs-calendar-container ovh mt16" *ngIf="isStartOpen" [@enterAndLeave]>
                <mat-calendar #startDateDatePicker [headerComponent]="headerComponent"
                    (selectedChange)="onCustomDateSocpeStartChange($event)" [(selected)]="customDateStart"
                    [minDate]="dateScopeStart" [maxDate]="endDate"
                    [startAt]="customDateStart?customDateStart:startDate"></mat-calendar>
            </div>
        </div>
        <div class="pct50 flex-v pl2em">
            <span class="sec-color pl2 f12">End Date</span>
            <div class="flex-h-c pct100 mt8">
                <ad-dropdown-list class="pct100" [isEmitChangeOutside]="false" [cssClass]="'dd-rounded-border'"
                    defaultText="{{customDateEnd?(customDateEnd | date:format):'Select an end date'}}"
                    [dataSource]="endDateItemOptions" textAlign="left" width="100%" (onChange)="onEndDateItemChange()"
                    [(ngModel)]="selectedEndOption">
                </ad-dropdown-list>
                <i class="fas fa-calendar poi primary-color f20 ml14" (click)="isEndOpen = !isEndOpen"></i>
            </div>
            <div class="rel a-drs-calendar-container ovh mt16" *ngIf="isEndOpen" [@enterAndLeave]>
                <mat-calendar #endDateDatePicker [headerComponent]="headerComponent" (selectedChange)="onCustomDateSocpeEndChange($event)"
                    [(selected)]="customDateEnd" [minDate]="startDate" [maxDate]="dateScopeEnd"
                    [startAt]="customDateEnd?customDateEnd:endDate"></mat-calendar>
            </div>
        </div>
    </div>
</div>
<ng-template #left>
    {{startDate|date:format}}
</ng-template>
<ng-template #right>
    {{endDate|date:format}}
</ng-template>

<!-- <ng-template cdkConnectedOverlay [cdkConnectedOverlayPositions]="overlayPosition"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOrigin]="startTrigger" (backdropClick)="overlayOutsideClick()"
    [cdkConnectedOverlayOpen]="isStartOpen">
<mat-calendar [headerComponent]="headerComponent"
                    (selectedChange)="onCustomDateSocpeStartChange($event)" [(selected)]="customDateStart"
                    [minDate]="dateScopeStart" [maxDate]="endDate"
                    [startAt]="customDateStart?customDateStart:startDate"></mat-calendar>
</ng-template> -->

<!-- <ng-template cdkConnectedOverlay [cdkConnectedOverlayPositions]="overlayPosition"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop" [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOrigin]="endTrigger" (backdropClick)="overlayOutsideClick()"
    [cdkConnectedOverlayOpen]="isEndOpen">
    <mat-calendar [headerComponent]="headerComponent" (selectedChange)="onCustomDateSocpeEndChange($event)"
        [(selected)]="customDateEnd" [minDate]="startDate" [maxDate]="dateScopeEnd"
        [startAt]="customDateEnd?customDateEnd:endDate"></mat-calendar>
</ng-template> -->